<template>
  <div>
    <div style="height: 100%">
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="姓名">
                  <el-input
                    v-model="form.userName"
                    clearable
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系电话">
                  <el-input
                    v-model="form.phone"
                    clearable
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>

                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="560"
          >
            <template v-slot:zcWorkStatus="{ scope }">
              <span v-if="scope.row.zcWorkStatus == 'on'">在职</span>
              <span v-if="scope.row.zcWorkStatus == 'off'">离职</span>
              <span v-if="scope.row.zcWorkStatus == 'transferred'">调离</span>
              <span v-if="scope.row.zcWorkStatus == 'retired'">休假</span>
              <span v-if="scope.row.zcWorkStatus == 'sick'">病休</span>
              <span v-if="scope.row.zcWorkStatus == 'retire'">退休</span>
            </template>
            <template v-slot:zcCheckStatus="{ scope }">
              <span>{{ scope.row.zcCheckStatus == 'pass' ? '审批通过' : scope.row.zcCheckStatus == 'reject' ? '审批不通过' : '待审批' }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="getUserDetailFun(scope.row.id)"
                style="color: #0090FF;font-size: 16px;"
                type="text"
                >审核</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <el-dialog
      title="审核"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="user-form">
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          label-position="top"
        >
          <el-form-item prop="accountName" label="登录名">
            <el-input
              v-model="formData.accountName"
              placeholder="登录名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="userName" label="真实姓名">
            <el-input
              v-model="formData.userName"
              placeholder="真实姓名"
            ></el-input>
          </el-form-item>

          <el-form-item prop="deptId" label="部门" class="tree-d">
            <el-cascader
              :props="props"
              v-model="formData.deptId"
              :options="deptTree"
              @change="handleChange"
              :show-all-levels="false"
              filterable
              style="width: 364px;"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="formData.phone" placeholder="手机号"></el-input>
          </el-form-item>
          <!-- 添加填写项 -->
          <!-- <el-form-item label="证件类型">
            <el-select
              filterable
              placeholder="请选择证件类型"
              clearable
              v-model="formData.idType"
            >
              <el-option label="身份证" value="1"></el-option>
              <el-option label="护照" value="2"></el-option>
              <el-option label="户口簿" value="3"></el-option>
              <el-option label="军人证" value="4"></el-option>
              <el-option label="港澳台居民身份证" value="5"></el-option>
              <el-option label="武警身份证" value="6"></el-option>
              <el-option label="边民出入境通行证" value="7"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="身份证号" prop="idcardNum">
            <el-input v-model="formData.idNo" placeholder="身份证号"></el-input>
          </el-form-item> -->
          <el-form-item prop="email" label="邮箱">
            <el-input v-model="formData.email" placeholder="邮箱"></el-input>
          </el-form-item>

          <el-form-item label="工作状态">
            <el-select
              filterable
              placeholder="请选择工作状态"
              clearable
              v-model="formData.zcWorkStatus"
            >
              <el-option label="在职" value="on"></el-option>
              <el-option label="离职" value="off"></el-option>
              <el-option label="调离" value="transferred"></el-option>
              <el-option label="休假" value="retired"></el-option>
              <el-option label="病休" value="sick"></el-option>
              <el-option label="退休" value="retire"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职务">
            <el-select
              filterable
              placeholder="请选择职务"
              clearable
              v-model="formData.zcWorkPosition"
            >
              <el-option
                v-for="(item, index) in positionOptions"
                :key="index"
                :label="item.data.itemName"
                :value="item.data.itemName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主要工作">
            <el-input
              v-model="formData.zcMainDuty"
              placeholder="主要工作"
            ></el-input>
          </el-form-item>
          <el-form-item label="平台角色" prop="roleIds">
            <el-cascader
              v-model="formData.roleIds"
              :options="roleData"
              :props="props1"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="客服角色">
            <el-cascader
              v-model="formData.roleIds2"
              :options="roleData2"
              :props="props1"
              clearable
            ></el-cascader>
          </el-form-item>

          <el-form-item label="审核状态" prop="zcCheckStatus">
            <el-radio-group v-model="formData.zcCheckStatus">
              <el-radio label="pass">审核通过</el-radio>
              <el-radio label="reject">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核意见">
            <el-input
              type="textarea"
              v-model="formData.zcCheckOpinion"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="formData.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          class="search"
          size="mini"
          @click="cancelcerat"
        >
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getUserList2,
  getDeptTree,
  checkStaff,
  getRoleArray,
  dictItemRoot,
  getRoleRoot,
  getUserDetail
} from "@/api/systemManagement";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    commonTable
  },
  data() {
    const _self = this;
    return {
      form: {
        userName: "",
        phone: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "userName",
            label: "用户名"
          },
          // {
          //   prop: "wxNickname",
          //   label: "微信昵称"
          // },
          {
            prop: "deptName",
            label: "部门"
          },
          {
            prop: "zcWorkPosition",
            label: "职务"
          },

          {
            prop: "phone",
            label: "联系电话"
          },
          {
            slot: "zcWorkStatus",
            label: "工作状态"
          },
          {
            prop: "zcMainDuty",
            label: "主要工作"
          },
          {
            slot: "zcCheckStatus",
            label: "审核状态"
          },
          {
            slot: "operation",
            label: "操作",
            width: 160
          }
        ]
      },
      dialogVisible: false,
      formData: {
        accountName: "",
        idType: "",
        zcUserType: "",
        zcWorkStatus: "",
        zcWorkPosition: "",
        zcMainDuty: "",
        userName: "",
        password: "",
        deptId: "",
        ghUserType: "",
        userType: "1",
        phone: "",
        idNo: null,
        email: "",
        remark: "",
        zcCheckOpinion: "",
        zcCheckStatus: "",
        status: 1,
        id: null,
        roleIds: [],
        roleIds2: ["1000010", "1000008"]
      },
      deptTree: [],
      props: {
        value: "id",
        label: "label",
        children: "children",
        checkStrictly: true,
        lazy: false, //设置lazyLoad，必须配合lazy：true
        async lazyLoad(node, resolve) {
          // 区域树懒加载的方法
          const { data } = node;
          if (
            (data && data.haveSon === false) ||
            (data && data.leaf === true)
          ) {
            return resolve([]);
          }
          let id;
          if (data) {
            id = data.id;
          } else {
            return resolve([]);
          }
          const temp = await _self.getSta(id);
          for (const item of temp.data) {
            item.leaf = item.level === "city";
          }
          resolve(temp.data);
        }
      },
      rules: {
        accountName: [
          { required: true, message: "请输入登录账号", trigger: "blur" }
        ],
        zcCheckStatus: [
          { required: true, message: "请选择审核状态", trigger: "blur" }
        ],
        userName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        deptId: [{ required: true, message: "请选择部门", trigger: "blur" }],

        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }
        ],
        roleIds: [{ required: true, message: "请选择平台角色", trigger: "blur" }]
      },
      positionOptions: [],
      roleValue: [],
      roleDatag: [],
      roleData: [],
      roleData2: [],
      props1: {
        multiple: true
      }
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
    this.dictItemRootFun();
    this.getTree();
    this.getrole();
  },
  methods: {
    // 查询角色下拉列表
    async getrole() {
      const res = await getRoleArray({});
      if (res.data.code == 200) {
        res.data.data.map(item => {
          if (item.type == 1) {
            this.roleData.push({
              label: item.value,
              value: item.id,
              children: null
            });
          }
          if (item.type == 3) {
            this.roleData2.push({
              label: item.value,
              value: item.id,
              children: null
            });
          }
          // console.log(this.roleData, "roleData");
        });
      }
    },
    async setRole() {
      let params = {
        id: this.formPermission.id,
        roleIds: this.formPermission.roleIds
      };
      const res = await setUserRole(params);
      if (res.data.code == 200) {
        this.$message({
          message: "角色绑定成功",
          type: "success"
        });
        this.roleValue = [];
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    async dictItemRootFun() {
      const { data } = await dictItemRoot({
        dictType: "ZC_WORK_POSITION",
        data: true,
        pid: -1,
        page: 1,
        size: 9999
      });
      this.positionOptions = data.data.dataList || [];
    },
    async getSta(pid) {
      const params = {
        name: "",
        id: "",
        pid: pid
      };
      const data = await getDeptTree(params);
      return data.data;
    },
    // 获取部门资源树形
    async getTree() {
      let params = {};
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptTree = res.data.data;
      }
    },
    handleChange(val) {
      this.formData.deptId = val[val.length - 1];
    },
    async getUserDetailFun(id) {
      const res = await getUserDetail(id);
      this.getValueDialog(res.data.data);
    },
    async getValueDialog(val) {
      this.dialogVisible = true;
      // this.formData.accountName = val.accountName;
      this.formData.accountName = val.phone;
      this.formData.idType = val.idType + "";
      this.formData.zcWorkStatus = val.zcWorkStatus;
      this.formData.zcWorkPosition = val.zcWorkPosition;
      this.formData.zcMainDuty = val.zcMainDuty;
      this.formData.userName = val.userName;
      this.formData.password = val.password;
      this.formData.deptId = val.deptId;
      this.formData.phone = val.phone;
      this.formData.idNo = val.idNo;
      this.formData.email = val.email;
      this.formData.remark = val.remark;
      this.formData.id = val.id;
      this.formData.zcCheckOpinion = val.zcCheckOpinion;
      this.formData.roleIds = val.roleIds;
      this.formData.zcCheckStatus = val.zcCheckStatus;
      this.formData.roleIds2 = ["1000010", "1000008"];
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.userName = "";
      this.form.phone = "";
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        userName: this.form.userName,
        phone: this.form.phone,
        page: this.page.page,
        size: this.page.size,
        queryRole: true,
        zcUserTypeLike: "staff"
      };
      const res = await getUserList2(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.dataList
          ? res.data.data.dataList
          : [];
        this.page.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
    },
    // 用户审批
    async cancelcerat() {
      let xx = true;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let roleIds = [];
      if (this.formData.roleIds.length) {
        roleIds = this.formData.roleIds.flat(Infinity);
      }
      if (this.formData.roleIds2.length) {
        roleIds = roleIds.concat(this.formData.roleIds2.flat(Infinity));
      }
      console.log(roleIds);

      let params = {
        accountName: this.formData.accountName,
        idType: this.formData.idType,
        zcWorkStatus: this.formData.zcWorkStatus,
        zcWorkPosition: this.formData.zcWorkPosition,
        zcMainDuty: this.formData.zcMainDuty,
        userName: this.formData.userName,
        password: this.formData.password,
        deptId: this.formData.deptId,
        userType: this.formData.userType,
        phone: Number(this.formData.phone),
        idNo: this.formData.idNo,
        email: this.formData.email,
        remark: this.formData.remark,
        ghUserType: this.formData.ghUserType,
        zcCheckOpinion: this.formData.zcCheckOpinion,
        zcCheckStatus: this.formData.zcCheckStatus,
        roleIds: roleIds,
        id: this.formData.id
      };
      const res = await checkStaff(params);
      if (res.data.code == 200) {
        this.formData.accountName = null;
        this.formData.userName = null;
        this.formData.password = null;
        this.formData.deptId = null;
        // this.formData.userType = "";
        this.formData.phone = null;
        this.formData.idNo = null;
        this.formData.email = null;
        this.formData.remark = null;
        this.formData.id = null;
        this.formData.idType = null;
        this.formData.zcUserType = null;
        this.formData.zcWorkStatus = null;
        this.formData.zcWorkPosition = null;
        this.formData.zcMainDuty = null;
        this.formData.roleIds = [];
        this.getPointTypeListPageFun();
        this.$message({
          message: "审核成功",
          type: "success"
        });
        this.dialogVisible = false;
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.question-detail {
  height: calc(100% - 56px);
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;

  .top {
    width: 100%;
    // height: 178px;
    padding: 24px 36px;
    background: url("~@/assets/image/question-bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .map-content {
    width: 375px;
    height: 178px;
    margin: 0 24px;
  }
}

.right-top1 {
  // width: 100%;
  margin-bottom: 8px;
  padding: 10px 24px;
  position: relative;

  .street {
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 24px;
    color: #494c4f;
    position: relative;
    .disposition {
      position: absolute;
      top: -10px;
      right: -80px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }
  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 54px;

      img,
      span {
        margin-right: 8px;
      }

      img {
        height: 15px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}

.right-bottom {
  height: calc(100% - 214px);
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 100px;
    padding-right: 24px;
    margin-bottom: 8px;

    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 20px;
        color: #92979c;
        margin-right: 48px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #0090ff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  padding: 20px 100px;
}
.taskDetail {
  /deep/ .el-form-item__label {
    text-align: left;
  }
}

.keyPic {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /deep/ .el-image {
    margin: 0 !important;
  }
  .imgPic {
    width: 234px;
    height: 234px;
    margin-right: 10px !important;
    border-radius: 4px;
  }
}

.fenbo {
  width: 410px;
  border-right: 1px solid #e0e0e0;
  margin-right: 20px;

  .list {
    width: 390px;

    height: 72px;
    background: #f7faff;
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #494c4f;
      line-height: 22px;
    }
    .assignType {
      margin-right: 8px;
      padding: 0 4px;
      height: 22px;
      background: rgba(138, 144, 154, 0.09);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 22px;
    }
    .zhuban {
      background: rgba(4, 149, 255, 0.1);
      color: #0495ff;
    }
    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 19px;
    }
    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }
  .activeList {
    border: 1px solid #0495ff;
  }
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.yituihui {
  color: #c4c6cc;
}
.user-form {
  /deep/.el-form {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/.el-form-item {
    width: 48%;
    .el-form-item__label {
      margin: 0;
      padding: 0;
    }
  }
  /deep/.el-form-item:nth-of-type(odd) {
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/shList.vue